import TicketComments from './TicketComments'
import TicketCreator from './TicketCreator'
import TicketEditor from './TicketEditor'

module.exports = {
  TicketCreator,
  TicketEditor,
  TicketComments
}



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/ticket/index.js